<template>
  <div class="maschinen-auswahl">
    <div class="container col12">
      <div :class="{'rw-tabs': !loading, vertical: true}">
        <div class="tabset">
          <div class="tab active">
            Maschinen
          </div>
        </div>
        <div class="tabs-container">
          <div class="tab-content">
            <p>Bitte geben Sie an, welche Maschinen bereits vorhanden oder in Planung sind.</p>
            <div v-if="!loading">
              <div class="maschine" v-for="(maschine, key) in vorhandeneMaschinen" :key="key">
                <div>
                  <select v-model="maschine.typ" @change="changeArt(maschine)">
                    <option value="" disabled>Maschinenart</option>
                    <option v-for="(typ, key) in maschinen" :key="key" :value="key">{{typ.name}}</option>
                  </select>
                </div>
                <div>
                  <select v-model="maschine.hersteller" @change="changeHersteller(maschine)" v-if="maschine.typ !== ''">
                    <option value="" disabled>Hersteller</option>
                    <option v-for="(typ, key) in maschinenHersteller(maschinen, maschine.typ)" :key="key" :value="key">{{typ.name}}</option>
                    <option value="__custom">Sonstige</option>
                  </select>
                </div>
                <div>
                  <select v-model="maschine.modell" @change="change(maschine)" v-if="(maschinenModelle(maschinen, maschine.typ, maschine.hersteller)).length !== 0 && maschine.hersteller !== '__custom' && maschine.hersteller !== ''">
                    <option value="" disabled>Modell</option>
                    <option v-for="(typ, key) in maschinenModelle(maschinen, maschine.typ, maschine.hersteller)" :key="key" :value="key">{{typ.name}}</option>
                  </select>
                  <input type="text" placeholder="Hersteller & Modell" v-if="maschine.hersteller === '__custom'" v-model="maschine.custom" @change="change(maschine)" />
                </div>
                <button class="delete-button" @click="remove(key)" v-if="!maschine['.unchanged']"><i class="icon-close"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Options from '@/Options'

function newMaschine () {
  return {
    typ: '',
    hersteller: '',
    modell: '',
    '.unchanged': true
  }
}

export default {
  name: 'MaschinenAuswahl',
  components: {
  },
  props: ['data'],
  data () {
    return {
      vorhandeneMaschinen: this.data || {'m0': newMaschine()},
      loading: true,
      maschinen: {},
      count: 1
    }
  },
  methods: {
    maschinenHersteller (maschinen, typ) {
      if (!typ || typ === '' || !maschinen[typ]) {
        return []
      } else {
        return maschinen[typ].hersteller
      }
    },
    maschinenModelle (maschinen, typ, hersteller) {
      if (!typ || typ === '' || !hersteller || hersteller === '' || !maschinen[typ] || !maschinen[typ].hersteller || !maschinen[typ].hersteller[hersteller] || !maschinen[typ].hersteller[hersteller].modelle) {
        return []
      } else {
        return maschinen[typ].hersteller[hersteller].modelle
      }
    },
    change (maschine) {
      if (maschine['.unchanged']) {
        this.$delete(maschine, '.unchanged')
        this.$set(this.vorhandeneMaschinen, 'm' + this.count, newMaschine())
        this.count += 1
      }
      this.$emit('change')
    },
    changeHersteller (maschine) {
      maschine.modell = ''
      if (maschine.hersteller !== '__custom' && !this.maschinen[maschine.typ].hersteller[maschine.hersteller].modelle) {
        this.change(maschine)
      }
      this.$emit('change')
    },
    changeArt (maschine) {
      maschine.hersteller = ''
      maschine.modell = ''
      this.$emit('change')
    },
    remove (key) {
      this.$delete(this.vorhandeneMaschinen, key)
    },
    getMaschinen () {
      return Object.values(this.vorhandeneMaschinen).filter(m => m['.unchanged'] !== true)
    },
    setMaschinen (data) {
      this.count = 0
      for (let key in this.vorhandeneMaschinen) {
        this.$delete(this.vorhandeneMaschinen, key)
      }
      for (let maschine of data) {
        this.$set(this.vorhandeneMaschinen, 'm' + this.count, maschine)
        this.count += 1
      }
      this.$set(this.vorhandeneMaschinen, 'm' + this.count, newMaschine())
      this.count += 1
    }
  },
  created () {
    Options.getOptions().then(options => {
      this.maschinen = options.maschinen
      this.loading = false
    })
  },
  computed: {
  },
  watch: {
    data (val) {
      this.vorhandeneMaschinen = val
    }
  }
}
</script>

<style scoped lang="scss">
@media screen and (min-width: 480px) {
  .maschine::after {
    content: '';
    display: table;
    clear: both;
  }
}

.maschine {
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 12px;
  margin-top: 12px;
  @media screen and (min-width: 480px) {
    height: 36px;
    margin-top: 6px;
    margin-bottom: 6px;
  }
}

.maschine > div {
  margin-right: 6px;
  width: 100%;
  margin-top: 6px;
  margin-bottom: 6px;
  @media screen and (min-width: 480px) {
    float: left;
    width: calc((100% - 60px) / 3);
    margin-top: 0;
    margin-bottom: 0;
  }
}

.maschine > div > * {
  width: 100%;
}

.maschine > button {
  width: 36px;
  float: left;
  height: 36px;
  line-height: 36px;
  padding: 0;
  color: #ec6608;
  background: transparent;
}

.maschine > button > i {
  line-height: 36px;
}

.maschine > button:hover {
  color: #d85200;
}

.tab-content {
  padding-bottom: 36px;
  padding-top: 12px !important;
  padding-left: 0 !important;
}

.tab-content > p {
  padding-left: 24px;
  padding-right: 24px;
}

@media screen and (max-width: 768px) {
  select {
    padding: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MaschinenAuswahl.vue